import { render } from "./InfoAboutDelivery.vue?vue&type=template&id=5916cec5&scoped=true&ts=true"
import script from "./InfoAboutDelivery.vue?vue&type=script&lang=ts"
export * from "./InfoAboutDelivery.vue?vue&type=script&lang=ts"

import "./InfoAboutDelivery.vue?vue&type=style&index=0&id=5916cec5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5916cec5"]])

export default __exports__